import React from 'react';

import { VideoTutorielDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

interface ModalDetailsProps {
  video: VideoTutorielDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  video,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <BaseModal
      width={BaseModalWidthUtils.xLargeWidth}
      isVisible={visible}
      closeModal={close}
      className="modalDetails"
    >
      <>
        <FieldDisplay
          label={LABEL_ID_CORRELATION}
          value={video.idCorrelation}
        />
        <FieldDisplay label="Profil" value={video.profile} />
        <FieldDisplay label="YouTube ID" value={video.videoId} />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
